import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Profile = t.type({
  id: t.string,
  name: t.string,
  avatarUrl: nullable(t.string),
  currentPoints: t.number
});
export var GetNavBarInfoQuery = t.type({
  profile: Profile,
  unreadNotifications: t.number
});
export var NavBlockLink = S.struct({
  typename: S.literal('NavBlockLink'),
  // unique name
  id: S.string,
  href: S.string,
  display: S.string
});
export var NavBlockGroup = S.struct({
  typename: S.literal('NavBlockGroup'),
  // unique name
  id: S.string,
  display: S.string,
  links: S.array(NavBlockLink)
});
export var NavBlockLogoLink = S.struct({
  typename: S.literal('NavBlockLogoLink'),
  id: S.string,
  href: S.string,
  display: S.string,
  imgUrl: S.string
});
export var NavBlockLogoGroup = S.struct({
  typename: S.literal('NavBlockLogoGroup'),
  id: S.string,
  display: S.string,
  links: S.array(NavBlockLink),
  imgUrl: S.string
});
export var NavBlockContent = S.union(NavBlockLink, NavBlockGroup, NavBlockLogoLink, NavBlockLogoGroup);
export var HomeLink = S.nullable(S.union(NavBlockLink, NavBlockLogoLink));
export var NavBlockConfig = S.struct({
  typename: S.literal('NavBlock'),
  id: S.string,
  hash: S.string,
  links: S.array(NavBlockContent),
  homeLink: HomeLink,
  signupEnabled: S["boolean"],
  signinEnabled: S["boolean"],
  notificationsEnabled: S["boolean"],
  profileEnabled: S["boolean"],
  messagingEnabled: S["boolean"],
  messagingLink: S.string,
  privacyPolicyLink: S.nullable(S.string),
  termsAndConditionsLink: S.nullable(S.string),
  actionBarLangSelectorEnabled: S["boolean"],
  navLangSelectorEnabled: S["boolean"]
});